const state = {
  settingdata: {
    ...(localStorage.getItem("settingdata")
      ? JSON.parse(localStorage.getItem("settingdata"))
      : {
          male: false, //男声
          female: true, //女声
          auto: true, //答错出现技巧
          next: true, //答对下一题
          tip: true, // 提示语音
          fonts: 30, //字体
          keySkill: false, // 关键字
        }),
  },
  dumiaoList: [], // 三力测试读秒题
};

const mutations = {
  SET_SETTING_DATA(state, settingData) {
    // 使用Object.assign进行浅拷贝，确保不会覆盖整个对象
    state.settingdata = Object.assign({}, state.settingdata, settingData);
    localStorage.setItem("settingdata", JSON.stringify(state.settingdata));
  },
  SET_DUMIAO_LIST(state, dumiaoList) {
    state.dumiaoList = dumiaoList; // 更新读秒题列表
  },
};

const actions = {
  setSettingData({ commit }, settingData) {
    commit("SET_SETTING_DATA", settingData);
  },
  setDumiaoList({ commit }, dumiaoList) {
    commit("SET_DUMIAO_LIST", dumiaoList);
  },
};

const getters = {
  settingdata: (state) => state.settingdata,
  dumiaoList: (state) => state.dumiaoList,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
